import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout,parseWashingFeatures,zeroFill,numericSortFunc,dateSortFunc,isSaudi } from "common/SharedFn";
import { getAllUsers,updateUser,bulkUpdateUserStatus,bulkUpdateUserPro ,getCities,bulkUpdateWelcomeKitSlots,getAllSlots, assignProTrial } from "../../network/ApiAxios";
import {  AccountBalanceWalletOutlined, Edit, MapOutlined, Share, TrendingUpOutlined } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";
import dateFormat from "dateformat";
import DatePicker from "react-datepicker";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const UsersTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [cities, setCities] = useState([]);
  const [slots, setSlots] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [portalNotes, setPortalNotes] = useState("");
  const [flat, setFlat] = useState("");
  const [building, setBuilding] = useState("");
  const [road, setRoad] = useState("");
  const [assignWelcomeKitModal, setAssignWelcomeKitModal] = useState(false);
  const [proTrialModal, setProTrialModal] = useState(false);
  const [dropoffDate, setDropoffDate] = useState();
  const [dropoffTimeslot, setDropoffTimeslot] = useState(0);
  const [districtName, setDistrictName] = useState("");
  const [shortAddress, setShortAddress] = useState("");
  const [block, setBlock] = useState("");
  const [birthday, setBirthday] = useState();
  const [familyStatus, setFamilyStatus] = useState(0);
  const [gender, setGender] = useState(0);
  const [cityId, setCityId] = useState(0);
  const [proFreeTrial, setProFreeTrial] = useState(0);
  const [subscriptionPilot, setSubscriptionPilot] = useState(0);
  const [shoesPilot, setShoesPilot] = useState(0);
  const [welcomeKitDate, setWelcomeKitDate] = useState();
  const [welcomeKitDateChanged, setWelcomeKitDateChanged] = useState(false);
  const [welcomeKitSlotId, setWelcomeKitSlotId] = useState(0);
  const [isActive, setIsActive] = useState(1);
  const [id, setId] = useState();
  const [newStatus, setNewStatus] = useState(1);
  const [ids, setIds] = useState([]);
  const [slotsUpdated, setSlotsUpdated] = useState(false);
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [executeStatusUpdate, setExecuteStatusUpdate] = useState(false);
  const [executeProUpdate, setExecuteProUpdate] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(TrendingUpOutlined);
  const [selectedCount, setSelectedCount] = useState(0);
  const [proTrialUserId, setProTrialUserId] = useState("");
  const [proTrialType, setProTrialType] = useState(7);
  let history = useHistory();

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    style: { backgroundColor: '#c8e6c9' },
    onSelect: (row, isSelect, rowIndex, e) => {
      if(isSelect){
        ids.push(row.id);
      }
      else{
        var index = ids.indexOf(row.id)
        if (index !== -1) {
          ids.splice(index, 1);
        }
      }
      setSelectedCount(ids.length);
    },
    onSelectAll: (isSelect, rows, e) => {
      if(isSelect){
        for (var i=0; i < rows.length; i++) {
          ids.push(rows[i].id);
        }
      }
      else{
        for (var i=0; i < rows.length; i++) {
          var index = ids.indexOf(rows[i].id);
          if (index !== -1) {
            ids.splice(index, 1);
          }
        }
      }
      setSelectedCount(ids.length);
    }
  };

  const bulkUpdateSlotsAction = async () => {
    setIsLoading(true);
    try {
      const response = await bulkUpdateWelcomeKitSlots(ids, dropoffDate, dropoffTimeslot,cityId,flat,building,road,districtName,shortAddress,block);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Welcome Kit assigned Successfully");
        setAssignWelcomeKitModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
        showErrorNotification("Failed to assign Welcome Kit");
        setIsLoading(false);
    }
  };

  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const accessReferralsPage = (id) => {
    let history = createHistory();
    history.push("/admin/users/referral/"+id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const accessWalletPage = (id) => {
    let history = createHistory();
    history.push("/admin/users/wallet/"+id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const accessAddressesPage = (id) => {
    let history = createHistory();
    history.push("/admin/users/address/"+id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };
  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const setCurrentRecord = (info) => {
    const { id,firstName,lastName,emailAddress,birthday,gender,proFreeTrial,familyStatus,cityId,isActive,flat,road,districtName,shortAddress,building,block,subscriptionPilot,shoesPilot,welcomeKitDate,welcomeKitSlotId,portalNotes} = info;
    setFirstName(firstName);
    setLastName(lastName);
    setEmailAddress(emailAddress);
    setBirthday(new Date(birthday));
    setGender(gender);
    setProFreeTrial(proFreeTrial);
    setPortalNotes(portalNotes);
    setFamilyStatus(familyStatus);
    setCityId(cityId);
    setIsActive(isActive);
    setBlock(block);
    setFlat(flat);
    setRoad(road);
    setDistrictName(districtName);
    setShortAddress(shortAddress);
    setBuilding(building);
    setSubscriptionPilot(subscriptionPilot);
    setShoesPilot(shoesPilot);
    if(welcomeKitDate != null){
      setWelcomeKitDate(new Date(welcomeKitDate.replaceAll("+03:00","+00:00")));
    }
    else{
      setWelcomeKitDate(new Date());
    }

    if(welcomeKitSlotId != null){
      setWelcomeKitSlotId(welcomeKitSlotId);
    }
    else{
      setWelcomeKitSlotId(null)
    }
    setId(id);
    setWelcomeKitDateChanged(true);
  };

  const clearCurrentRecord = () => {
    setFirstName("");
    setLastName("");
    setPortalNotes("");
    setEmailAddress("");
    setFlat("");
    setRoad("");
    setDistrictName("");
    setShortAddress("");
    setBuilding("");
    setBlock("");
    setBirthday();
    setGender(0);
    setProFreeTrial(0);
    setFamilyStatus(0);
    setCityId(0);
    setIsActive(1);
    setSubscriptionPilot(0);
    setShoesPilot(0);
    setId();
  };


  // const fetchSlots = async () => {
  //   setWelcomeKitDateChanged(false);
  //   setSlotsUpdated(false);
  //   try{
  //   const responseSlotsList = await getSlotsForDate(new Date((welcomeKitDate.getTime())),3,welcomeKitSlotId);
  //   if (responseSlotsList.data.result.isSuccess) {
  //     if(responseSlotsList.data.data != null){
  //       setSlots(responseSlotsList.data.data);
  //     }
  //     else{
  //       setSlots([]);
  //     }
  //     setSlotsUpdated(true);
  //   } else {
  //     showErrorNotification(data.result.description);
  //     if(data.result.code == -2){
  //       redirectToLogout();
  //     }
  //   }
  //   }
  //   catch(ex){
  //     showErrorNotification("Failed to fetch slots "+ex);
  //   }
  // };

  const fetchUsers = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllUsers();
    const { data } = response;
    const responseCities = await getCities(localStorage.getItem("selectedCountry"));
    const responseSlotsList = await getAllSlots();
    if (data.result.isSuccess) {
      setCities(responseCities.data.data);
      setSlots(responseSlotsList.data.data);
      setData(data.data.map((prop) => makeTableRow(prop)));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch users");
    }
    setIsLoading(false);
  };


  const updateUserAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try{
    const response = await updateUser(id,firstName,lastName,emailAddress,new Date((birthday.getTime() + 86400000)),gender,familyStatus,cityId,isActive,flat,building,road,districtName,shortAddress,block,subscriptionPilot,shoesPilot,portalNotes,proFreeTrial); //Add one day to birthday for timezone difference
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("User Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update user");
      setIsLoading(false);
    }
  };


  const bulkUpdateUserStatusAction = async () => {
    setExecuteStatusUpdate(false);
    setIsLoading(true);
    try{
    const response = await bulkUpdateUserStatus(ids,newStatus);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Users Status Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update users status");
      setIsLoading(false);
    }
  };

  

  const bulkUpdateUserProAction = async () => {
    setExecuteProUpdate(false);
    setIsLoading(true);
    try{
    const response = await bulkUpdateUserPro(ids,newStatus);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Pro Free Trial Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update users free trials");
      setIsLoading(false);
    }
  };

  const assignProTrialAction = async () => {
    setIsLoading(true);
    try {
    
      const response = await assignProTrial(proTrialUserId, parseInt(proTrialType));
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Pro Trial Assigned Successfully");
        setProTrialModal(false);
        setProTrialUserId("");
        setProTrialType(7);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
        showErrorNotification("Failed to assign Pro Trial");
        setIsLoading(false);
    }
  };

  useAsyncEffect(async () => {
    // if(welcomeKitDateChanged && welcomeKitDate != null){
    //   fetchSlots();
    // }
    // else if(slots != null && slots.length>0 && (welcomeKitSlotId == null || welcomeKitSlotId == 0)){
    //   setWelcomeKitSlotId(slots[0].id);
    // }
    if(executeUpdate){
        updateUserAction();
    }
    else if(executeStatusUpdate){
      bulkUpdateUserStatusAction();
    }
    else if(executeProUpdate){
      bulkUpdateUserProAction();
    }
    else if(forceRefresh){
      fetchUsers();
    }
  }, [executeUpdate,executeStatusUpdate,executeProUpdate,forceRefresh,/*welcomeKitDateChanged,*/isLoading,slotsUpdated]);

  const makeTableRow = (info) => {
    switch(info.isActive){
      case 0:
        info.isActiveText = "Waiting List";
        break; 
      case 1:
        info.isActiveText = "Active";
        break;
      case 2:
        info.isActiveText = "Blocked";
        break;
      case 3:
        info.isActiveText = "Deleted";
        break;
    }
    switch(info.gender){
      case 0:
        info.genderText = "Female";
        break; 
      case 1:
        info.genderText = "Male";
        break;
    }
    
    switch(info.proFreeTrial){
      case 0:
        info.proFreeTrialText = "No";
        break;
        case 1:
          info.proFreeTrialText = "Yes";
          break;
    }

    switch(info.isPro){
      case 0:
        info.isProText = "No";
        break;
        case 1:
          info.isProText = "Yes";
          break;
    }
    switch(info.familyStatus){
      case 0:
        info.familyStatusText = "Single";
        break; 
      case 1:
        info.familyStatusText = "Couple";
        break;
      case 2:
        info.familyStatusText = "Family";
        break;
    }

    if(info.subscriptionPilot === 1){
      info.subscriptionPilotText = "Yes";
    }
    else{
      info.subscriptionPilotText = "No";
    }
    if(info.shoesPilot === 1){
      info.shoesPilotText = "Yes";
    }
    else{
      info.shoesPilotText = "No";
    }

    if(info.birthday == null || info.birthday == ''){
      info.birthdayText = '';
    }
    else{
      info.birthdayText = dateFormat(
        new Date(info.birthday),
        "d-mmm-yyyy"
      );
    }
    info = parseWashingFeatures(info);
    
    if(info.welcomeKitDate != null && info.welcomeKitDate != ''){
    if(info.welcomeKitSlotId != null){
      info.welcomeKitTimeText =
        info.welcomeKitStartTime +
        " - " +
        info.welcomeKitEndTime;
    }
      info.welcomeKitDateText = 
          dateFormat(new Date(info.welcomeKitDate), "d-mmm-yyyy");
          if(info.welcomeKitSlotId != null){
      info.welcomeKitDatetimeText = 
      info.welcomeKitDateText +' '+ info.welcomeKitTimeText
          }
    }
    else{
      info.welcomeKitDatetimeText = "";
    }

    info.walletBalance = info.walletBalance.toFixed(3);
    info.walletCashBalance = info.walletCashBalance.toFixed(3);
    info.walletNonCashBalance = info.walletNonCashBalance.toFixed(3);

  
    if(info.referredBy != null && info.referredBy !== 0 && info.referredBy !== ''){
      info.referredBy = "C"+zeroFill(info.referredBy,5)
    }
    else{
      info.referredBy = '';
    }
    
    return {
      ...info,
      idForm: (
        "C"+zeroFill(info.id,5)
      ),
      actions: (
        <div className="actions-right">
          <Tooltip title="User Addresses">
            <Button size="small" color="primary" variant="contained" onClick={() => {
                accessAddressesPage(info.id);
            }}>
              <Box component={MapOutlined} />
            </Button>
          </Tooltip>
          <Tooltip title="User Wallet">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedSuccess,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }} onClick={() => {
                accessWalletPage(info.id);
            }}>
              <Box component={AccountBalanceWalletOutlined} />
            </Button>
          </Tooltip>
          <Tooltip title="User Referrals">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedInfo,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }} onClick={() => {
                accessReferralsPage(info.id);
            }}>
              <Box component={Share} />
            </Button>
          </Tooltip>
          <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                    clearCurrentRecord();
                setCurrentRecord(info);
                setAddModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Users</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "idForm",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "firstName",
                    text: "First Name",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "lastName",
                    text: "Last Name",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "isProText",
                    text: "Pro User",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "emailAddress",
                    text: "Email Address",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "mobileNumber",
                    text: "Mobile Number",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "userNotes",
                    text: "User Notes",
                    sort: true,
                  },
                  {
                    dataField: "walletBalance",
                    text: "Wallet Balance",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "walletCashBalance",
                    text: "Wallet Cash Balance",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "walletNonCashBalance",
                    text: "Wallet Non Cash Balance",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "genderText",
                    text: "Gender",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "proFreeTrialText",
                    text: "Has Pro Free Trial",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "portalNotes",
                    text: "Notes",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "familyStatusText",
                    text: "Family Status",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "referralCode",
                    text: "Referral Code",
                    headerStyle: {display : "none"},
                    style : {display : "none"}        
                  },
                  {
                    dataField: "referredUsers",
                    text: "Referred Users",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "referredBy",
                    text: "Referred By",
                    sort: true,
                    style: {'whiteSpace': 'normal'}     
                  },
                  {
                    dataField: "birthdayText",
                    text: "Birthday",
                    sort: true,
                    style: {'whiteSpace': 'normal'},
                  },
                  {
                    dataField: "cityName",
                    text: "City",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "flat",
                    text: "Flat",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "building",
                    text: "Building",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "road",
                    text: "Road",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "districtName",
                    text: "District Name",
                    sort: true,
                    headerStyle: isSaudi() ? {} : {display : "none"},
                    style : isSaudi() ? {} : {display : "none"},
                    csvExport: isSaudi()
                  },
                  {
                    dataField: "block",
                    text: "Block",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "shortAddress",
                    text: "shortAddress",
                    sort: true,
                    headerStyle: isSaudi() ? {} : {display : "none"},
                    style : isSaudi() ? {} : {display : "none"},
                    csvExport: isSaudi()
                  },
                  {
                    dataField: "isActiveText",
                    text: "Status",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "subscriptionPilotText",
                    text: "Subscription Pilot",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "shoesPilotText",
                    text: "Shoes Pilot",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "registeredOnText",
                    text: "Registered On",
                    sort: true,
                    sortFunc: dateSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "welcomeKitDatetimeText",
                    text: "Welcome Kit Del. Slot",
                    sort: true,
                    sortFunc: dateSortFunc,
                    csvExport: false,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "welcomeKitDateText",
                    text: "Welcome Kit Date",
                    headerStyle: {display : "none"},
                    style : {display : "none"}        
                  },
                  {
                    dataField: "welcomeKitTimeText",
                    text: "Welcome Kit Time Slot",
                    headerStyle: {display : "none"},
                    style : {display : "none"}        
                  },
                  {
                    dataField: "scent",
                    text: "Scent",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "starch",
                    text: "Starch",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "thobeBackCrease",
                    text: "Thobe Back Crease",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "ghetra",
                    text: "Ghetra Crease",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "shirtsSleeveCrease",
                    text: "Shirts Sleeve Crease",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "pantsTravelersCrease",
                    text: "Pants Travelers Crease",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "lastLanguage",
                    text: "Language",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "devices",
                    text: "Devices",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "actions",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >

                      <Tooltip
                        title="Activate Selected Users"
                        style={{ margin: "5px" }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          classes={{
                            root: classes.buttonContainedSuccess,
                          }}
                          onClick={() => {
                            if(ids.length>0){
                              {warningAlert("Activate Users","Are you sure you would like to activate the selected "+ids.length+" users?",async () =>  {
                                setIds(ids);
                                setNewStatus(1);
                                setAlert(null);
                                setExecuteStatusUpdate(true);
                              })}
                            }
                          }}
                        >
                          <span>Activate Users</span>
                        </Button>
                      </Tooltip>

                      <Tooltip
                        title="Block Selected Users"
                        style={{ margin: "5px" }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          classes={{
                            root: classes.buttonContainedError,
                          }}
                          onClick={() => {
                            if(ids.length>0){
                              {warningAlert("Block Users","Are you sure you would like to block the selected "+ids.length+" users?",async () =>  {
                                setIds(ids);
                                setNewStatus(2);
                                setAlert(null);
                                setExecuteStatusUpdate(true);
                              })}
                            }
                          }}
                        >
                          <span>Block Users</span>
                        </Button>
                      </Tooltip>
                      <Tooltip
                        title="Move Selected Users to Waiting List"
                        style={{ margin: "5px" }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          classes={{
                            root: classes.buttonContainedWarning,
                          }}
                          onClick={() => {
                            if(ids.length>0){
                              {warningAlert("Waitlist Users","Are you sure you would like to waitlist the selected "+ids.length+" users?",async () =>  {
                                setIds(ids);
                                setNewStatus(0);
                                setAlert(null);
                                setExecuteStatusUpdate(true);
                              })}
                            }
                          }}
                        >
                          <span>Waiting List</span>
                        </Button>
                      </Tooltip>


                      {/* <Tooltip
                        title="Add Pro Free Trial"
                        style={{ margin: "5px" }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          classes={{
                            root: classes.buttonContainedInfo,
                          }}
                          onClick={() => {
                            if(ids.length>0){
                              {warningAlert("Pro Free Trial","Are you sure you would like to add a free month pro trial to the selected "+ids.length+" users?",async () =>  {
                                setIds(ids);
                                setNewStatus(1);
                                setAlert(null);
                                setExecuteProUpdate(true);
                              })}
                            }
                          }}
                        >
                          <span>Add Pro Free Trial</span>
                        </Button>
                      </Tooltip>


                      <Tooltip
                        title="Remove Pro Free Trial"
                        style={{ margin: "5px" }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          classes={{
                            root: classes.buttonContainedError,
                          }}
                          onClick={() => {
                            if(ids.length>0){
                              {warningAlert("Pro Free Trial","Are you sure you would like to remove the free month pro trial to the selected "+ids.length+" users?",async () =>  {
                                setIds(ids);
                                setNewStatus(0);
                                setAlert(null);
                                setExecuteProUpdate(true);
                              })}
                            }
                          }}
                        >
                          <span>Remove Pro Free Trial</span>
                        </Button>
                      </Tooltip> */}

                      <Tooltip
                        title="Assign Pro Free Trial"
                        style={{ margin: "5px" }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          classes={{
                            root: classes.buttonContainedInfo,
                          }}
                          onClick={() => {
                            setProTrialUserId("");
                            setProTrialType(7);
                            setProTrialModal(true);
                          }}
                        >
                          <span>Assign Pro Free Trial</span>
                        </Button>
                      </Tooltip>

                      <Tooltip
                        title="Assign Welcome Kit"
                        style={{ margin: "5px" }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          classes={{
                            root: classes.buttonContainedSuccess,
                          }}
                          onClick={() => {
                            if(ids.length>0){
                              clearCurrentRecord();
                              setAssignWelcomeKitModal(true);
                            }
                          }}
                        >
                          <span>Assign Welcome Kit</span>
                        </Button>
                      </Tooltip>

                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                          <ExportCSVButton
                            className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                            {...props.csvProps}
                          >
                            <span className="MuiButton-label">Download</span>
                          </ExportCSVButton>
                        {/* </Tooltip> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>
                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <div
                            style={{
                              marginBottom: "20px",
                            }}
                          >
                        {selectedCount} Users Selected
                        </div>
                      </Grid>
                    </Grid>
                    <BootstrapTable
                      keyField='id'
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      selectRow={ selectRow }
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={addModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddModal(false)}
              >
                <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    {id == null || id === "" ? "Add" : "Edit"} User
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>
                  {/* imageUrl */}
                <FormGroup>
                  <FormLabel>First Name</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="First Name"
                    value={firstName ?? ""}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Last Name</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Last Name"
                    value={lastName ?? ""}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Email Address</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="email"
                    placeholder="Email Address"
                    value={emailAddress ?? ""}
                    onChange={(e) => setEmailAddress(e.target.value)}
                  />
                </FormGroup>
                

                <FormGroup>
                  <FormLabel>Birthday</FormLabel>
                <DatePicker
                    selected={birthday}
                    fullWidth
                    customInput={<OutlinedInput fullWidth/>}
                    onChange={(date) => setBirthday(date)}
                    dateFormat="MMMM d, yyyy"
                  />
                  </FormGroup>

                <FormGroup>
                  <FormLabel>Gender</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={gender} onChange={(e) => setGender(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>Female</MenuItem>
                      <MenuItem value={1}>Male</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>


                <FormGroup>
                  <FormLabel>Has Pro Free Trial</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={proFreeTrial} onChange={(e) => setProFreeTrial(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>

                <FormGroup>
                  <FormLabel>Notes</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="notes"
                    value={portalNotes ?? ""}
                    multiline={true}
                    rows={5}
                    onChange={(e) => setPortalNotes(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Family Status</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={familyStatus} onChange={(e) => setFamilyStatus(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>Single</MenuItem>
                      <MenuItem value={1}>Couple</MenuItem>
                      <MenuItem value={2}>Family</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                
                <FormGroup>
                  <FormLabel>City</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={cityId} onChange={(e) => setCityId(e.target.value)} IconComponent={KeyboardArrowDown}>
                    {cities.map(function(city, i){
                        return <MenuItem value={city.id}>{city.cityEn}</MenuItem>;
                    })}
                    </Select>
                  </FormControl>
                </FormGroup>


                <FormGroup>
                  <FormLabel>Flat</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Flat"
                    value={flat ?? ""}
                    onChange={(e) => setFlat(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Building</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Building"
                    value={building ?? ""}
                    onChange={(e) => setBuilding(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Road</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Road"
                    value={road ?? ""}
                    onChange={(e) => setRoad(e.target.value)}
                  />
                </FormGroup>

                { isSaudi() ? (
                <FormGroup>
                  <FormLabel>District Name</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="District Name"
                    value={districtName ?? ""}
                    onChange={(e) => setDistrictName(e.target.value)}
                  />
                </FormGroup>) : ('')
                }
                <FormGroup>
                  <FormLabel>Block Number</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Block Number"
                    value={block ?? ""}
                    onChange={(e) => setBlock(e.target.value)}
                  />
                </FormGroup>

                { isSaudi() ? (
                <FormGroup>
                  <FormLabel>Short Address</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Short Address"
                    value={shortAddress ?? ""}
                    onChange={(e) => setShortAddress(e.target.value)}
                  />
                </FormGroup>) : ('')
                }
                <FormGroup>
                  <FormLabel>Status</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={isActive} onChange={(e) => setIsActive(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>Waiting List</MenuItem>
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={2}>Blocked</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>


                <FormGroup>
                  <FormLabel>Subscription Pilot</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={subscriptionPilot} onChange={(e) => setSubscriptionPilot(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                
                <FormGroup>
                  <FormLabel>Shoes Pilot</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={shoesPilot} onChange={(e) => setShoesPilot(e.target.value)} IconComponent={KeyboardArrowDown}>
                    <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
{/* 
                <FormGroup>
                    <FormLabel>Welcome Kit Delivery Date</FormLabel>
                    <DatePicker
                      selected={welcomeKitDate}
                      fullWidth
                      customInput={<OutlinedInput fullWidth />}
                      onChange={(date) => {
                        setWelcomeKitSlotId(null);
                        setWelcomeKitDate(date);
                         setWelcomeKitDateChanged(true);}}
                      dateFormat="MMMM d, yyyy"
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Welcome Kit Delivery Timeslot</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      {<Select
                        value={welcomeKitSlotId}
                        onChange={(e) => {setWelcomeKitSlotId(e.target.value);}}
                        IconComponent={KeyboardArrowDown}
                      >
                        {slots
                          //.sort((a, b) => (a.startTime > b.startTime ? 1 : -1))
                          .map(function (slot, i) {
                            if (
                              slot != null &&
                              welcomeKitDate != null &&
                              //slot.dayId == (welcomeKitDate.getDay() + 1) &&
                              (slot.deliveryType == 3 || slot.deliveryType == 2)
                            ) {

                              return (
                                <MenuItem value={slot.id}>
                                  {slot.startTime} - {slot.endTime} ({slot.driverByDriverId != null ? slot.driverByDriverId.fullNameEn : ''})
                                </MenuItem>
                              );
                            }
                          })}
                      </Select>
                      }
                    </FormControl>
                  </FormGroup> */}

                  </form>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setAddModal(false)}
                  >
                    Cancel
                  </Button>
                    <Button
                      onClick={() =>
                        updateUserAction()
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                       Update
                    </Button>
                  
                </DialogActions>
              </Dialog>
              <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={assignWelcomeKitModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
              >
                <DialogTitle disableTypography className={classes.modalHeader}>
                  <h4 className={classes.modalTitle}>Assign Welcome Kit</h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>
                    <Grid container justify="space-between">
                      <Grid item xs={12} sm={12} md={12}>

                      <FormGroup>
                          <FormLabel>Dropoff Date</FormLabel>
                          <DatePicker
                            selected={dropoffDate}
                            fullWidth
                            customInput={<OutlinedInput fullWidth />}
                            onChange={(date) => setDropoffDate(date)}
                            dateFormat="MMMM d, yyyy"
                          />
                        </FormGroup>

                        <FormGroup>
                          <FormLabel>Dropoff Timeslot</FormLabel>
                          <FormControl variant="outlined" fullWidth>
                            <Select
                              value={dropoffTimeslot}
                              onChange={(e) => setDropoffTimeslot(e.target.value)}
                              IconComponent={KeyboardArrowDown}
                            >
                              {slots
                                .sort((a, b) => (a.startTime > b.startTime ? 1 : -1))
                                .map(function (slot, i) {
                                  if (
                                    dropoffDate != null &&
                                    slot.dayId == dropoffDate.getDay() + 1 &&
                                    (slot.deliveryType == 0 || slot.deliveryType == 2) && slot.isSubscription == 0
                                  ) {
                                    return (
                                      <MenuItem value={slot.id}>
                                        {slot.startTime} - {slot.endTime} ({slot.driverByDriverId != null ? slot.driverByDriverId.fullNameEn : ''})
                                      </MenuItem>
                                    );
                                  }
                                })}
                            </Select>
                          </FormControl>
                        </FormGroup>

                <FormGroup>
                  <FormLabel>City</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={cityId} onChange={(e) => setCityId(e.target.value)} IconComponent={KeyboardArrowDown}>
                    {cities.map(function(city, i){
                        return <MenuItem value={city.id}>{city.cityEn}</MenuItem>;
                    })}
                    </Select>
                  </FormControl>
                </FormGroup>


                <FormGroup>
                  <FormLabel>Flat</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Flat"
                    value={flat ?? ""}
                    onChange={(e) => setFlat(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Building</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Building"
                    value={building ?? ""}
                    onChange={(e) => setBuilding(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Road</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Road"
                    value={road ?? ""}
                    onChange={(e) => setRoad(e.target.value)}
                  />
                </FormGroup>

                { isSaudi() ? (
                <FormGroup>
                  <FormLabel>District Name</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="District Name"
                    value={districtName ?? ""}
                    onChange={(e) => setDistrictName(e.target.value)}
                  />
                </FormGroup>) : ('')
                }
                <FormGroup>
                  <FormLabel>Block Number</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Block Number"
                    value={block ?? ""}
                    onChange={(e) => setBlock(e.target.value)}
                  />
                </FormGroup>

                { isSaudi() ? (
                <FormGroup>
                  <FormLabel>Short Address</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Short Address"
                    value={shortAddress ?? ""}
                    onChange={(e) => setShortAddress(e.target.value)}
                  />
                </FormGroup>) : ('')
                }
                      </Grid>
                    </Grid>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setAssignWelcomeKitModal(false)}>Cancel</Button>
                  <Button
                    onClick={() => bulkUpdateSlotsAction()}
                    classes={{
                      root: classes.buttonContainedPurple100,
                    }}
                    variant="contained"
                  >
                    Assign
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={proTrialModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
              >
                <DialogTitle disableTypography className={classes.modalHeader}>
                  <h4 className={classes.modalTitle}>Assign Pro Free Trial</h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>
                    <Grid container justify="space-between">
                      <Grid item xs={12} sm={12} md={12}>
                        <FormGroup>
                          <FormLabel>User ID</FormLabel>
                          <OutlinedInput
                            fullWidth
                            type="text"
                            placeholder="Add it without leading C and zeros"
                            value={proTrialUserId ?? ""}
                            onChange={(e) => setProTrialUserId(e.target.value)}
                          />
                        </FormGroup>
                        <FormGroup>
                          <FormLabel>Pro Trial Type</FormLabel>
                          <FormControl variant="outlined" fullWidth>
                            <Select value={proTrialType} onChange={(e) => setProTrialType(e.target.value)} IconComponent={KeyboardArrowDown}>
                              <MenuItem value="7">Weekly</MenuItem>
                              <MenuItem value="1">Monthly</MenuItem>
                            </Select>
                          </FormControl>
                        </FormGroup>
                      </Grid>
                    </Grid>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setProTrialModal(false)}>Cancel</Button>
                  <Button
                    onClick={() => assignProTrialAction()}
                    classes={{
                      root: classes.buttonContainedPurple100,
                    }}
                    variant="contained"
                  >
                    Assign
                  </Button>
                </DialogActions>
              </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default UsersTable;
